import { render } from "./GybLists.vue?vue&type=template&id=01f995fc"
import script from "./GybLists.vue?vue&type=script&lang=js"
export * from "./GybLists.vue?vue&type=script&lang=js"

import "./GybLists.vue?vue&type=style&index=0&id=01f995fc&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__